import { colors, fonts } from "../../styles/theme";

export const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  fontSize: 13,
  fontFamily: fonts.body,
  border: `1px solid ${colors.border}`,
  borderRadius: 6,
  background: colors.bg,
  color: colors.text,
  outline: "none",
  boxSizing: "border-box",
};

export const labelStyle = {
  display: "block",
  fontSize: 11,
  color: colors.textSecondary,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: 5,
  fontFamily: fonts.body,
  fontWeight: 600,
};

export const STATUS_MAP = {
  scheduled: {
    label: "Scheduled",
    color: colors.info,
    bg: "rgba(99,102,241,0.10)",
  },
  completed: {
    label: "Completed",
    color: colors.success,
    bg: "rgba(16,185,129,0.10)",
  },
  cancelled: {
    label: "Cancelled",
    color: colors.danger,
    bg: "rgba(239,68,68,0.10)",
  },
};

export const INVITATION_STATUS = {
  invited: {
    label: "Invited",
    color: colors.warning,
    bg: "rgba(245,158,11,0.10)",
  },
  registered: {
    label: "Registered",
    color: colors.success,
    bg: "rgba(16,185,129,0.10)",
  },
};
